export const selectSalonServicesCategories = ($) => $?.salon?.services?.categories;
export const selectSalonIsServicesCategoriesFetched = ($) => Array.isArray($?.salon?.services?.categories);
